import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type ICategory} from '@netx/core-category-next/schema';

/**
 * `getCategories` request params
 * (what is used to send to server)
 */
export interface GetCategoriesRequestOptions {
	id: number;
	search?: string;
}

/**
 * `getCategories` request
 * (what gets sent to the server)
 */
export type GetCategoriesRequest = [
	Required<GetCategoriesRequestOptions>['search'],
	GetCategoriesRequestOptions['id'],
];

/**
 * `getCategories` response
 * (what comes back from the server)
 */
export type GetCategoriesResponse = SuccessResponse<GetCategoriesResult>;

/**
 * `getCategories` result
 * (what is utilized from the server response)
 */
export type GetCategoriesResult = ICategory[];

export const getCategoriesEndpoint = 'getCategories';

/**
 * Get child categories
 * @param fetchParams Fetch params
 */
export const getCategories = async (
	{id, search = ''}: GetCategoriesRequestOptions,
	signal?: AbortSignal,
): Promise<ICategory[]> => {
	const client = NetxQueryClient();

	const requestParams: GetCategoriesRequest = [search, id];

	return client
		.post<GetCategoriesResponse>(getCategoriesEndpoint, requestParams, {signal})
		.then((response) =>
			response.data.result.map((cat) => ({...cat, id: cat.categoryid})),
		);
};
export default getCategories;
